module.exports = __webpack_public_path__ + "img/ganen-pop.3d99894f.png";